import React from 'react';
import { Button, message } from 'antd';
import SelectPlace from './SelectPlace';
import ActiveSites from './ActiveSites';
import { cloneDeep } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { FormattedMessage as FM, injectIntl } from 'react-intl';

/**
 * 选择地点组件
 */
class ClockInPlace extends React.Component {
  constructor(props) {
    super(props);
    const sites = cloneDeep(props.sites).map(item => {
      return {
        ...item,
        key: uuidv4(),
        expansion: false
      };
    });
    const jobs = cloneDeep(props.jobs);
    this.state = {
      sites,
      jobs
    };
  }
  componentDidMount = () => {};
  componentWillUnmount = () => {};

  validSite = site => {
    const {
      intl: { formatMessage }
    } = this.props;
    if (!site.name) {
      message.error(formatMessage({ id: 'ClockInPlace.tipAddressName' }));
      return false;
    }

    if (!site.selectedJobs.length) {
      message.error(formatMessage({ id: 'ClockInPlace.tipJobs' }));
      return false;
    }
    if (!site.address.cities.length) {
      message.error(formatMessage({ id: 'ClockInPlace.tipCities' }));
      return false;
    }

    return true;
  };

  handleSiteDone = (id, site) => {
    const valid = this.validSite(site);
    if (!valid) return;

    const { onChange } = this.props;
    const { sites } = this.state;
    const siteIndex = sites.findIndex(site => site.id === id);
    const newSite = {
      ...sites[siteIndex],
      ...site,
      key: uuidv4(),
      expansion: false
    };
    const newSites = [...sites];
    newSites.splice(siteIndex, 1, newSite);

    this.setState({ sites: newSites });
    onChange && onChange(cloneDeep(newSites));
  };

  handleDelete = id => {
    const { onChange } = this.props;
    const { sites } = this.state;
    const siteIndex = sites.findIndex(site => site.id === id);

    const newSites = [...sites];
    newSites.splice(siteIndex, 1);

    this.setState({ sites: newSites });
    onChange && onChange(cloneDeep(newSites));
  };

  handleAddSite = () => {
    const { sites } = this.state;
    const newSites = [
      ...sites,
      {
        id: uuidv4(),
        key: uuidv4(),
        name: '',
        address: {
          cities: [],
          cityCode: 0,
          detail: '',
          radius: 1,
          location: null
        },
        selectedJobs: [],
        expansion: true,
        enabled: true
      }
    ];
    this.setState({ sites: newSites });
  };

  handleExpansionChange = (id, expansion) => {
    const { sites } = this.state;
    const siteIndex = sites.findIndex(site => site.id === id);
    const newSite = { ...sites[siteIndex], expansion };
    const newSites = [...sites];
    newSites.splice(siteIndex, 1, newSite);
    this.setState({ sites: newSites });
  };

  handleCheckedChange = (id, checked) => {
    const { sites } = this.state;
    const siteIndex = sites.findIndex(site => site.id === id);
    const newSite = { ...sites[siteIndex], enabled: checked };
    const newSites = [...sites];
    newSites.splice(siteIndex, 1, newSite);
    this.setState({ sites: newSites });
    const { onChange } = this.props;
    onChange && onChange(cloneDeep(newSites));
  };

  getEnabledCount = () => {
    const { sites } = this.state;
    return sites.filter(site => site.enabled).length;
  };

  getLocations = () => {
    const { sites } = this.state;
    return sites
      .map(site => {
        if (site.enabled && site.address.radius && site.address.location) {
          return {
            id: site.id,
            radius: site.address.radius,
            lat: site.address.location.lat,
            lng: site.address.location.lng
          };
        }
      })
      .filter(Boolean);
  };

  render() {
    const { sites, jobs } = this.state;
    const { mapKey, fenceSizeMax } = this.props;
    const count = this.getEnabledCount();
    const locations = this.getLocations();

    return (
      <div className="clock-in-place">
        <div className="clock-in-place__left">
          <div className="clock-in-place__header">
            <div className="clock-in-place__header-left">
              <div className="clock-in-place__header-title">
                <FM id="ClockInPlace.sites" defaultMessage="地点" />({count})
              </div>
              <div className="clock-in-place__header-sub-title">
                <FM
                  id="ClockInPlace.tips"
                  defaultMessage="用户能够在指定范围内打卡"
                />
              </div>
            </div>
            <Button shape="round" onClick={this.handleAddSite}>
              + <FM id="ClockInPlace.addSite" defaultMessage="添加地点" />
            </Button>
          </div>
          <div className="clock-in-place__content">
            {sites.map(site => (
              <SelectPlace
                key={site.key}
                name={site.name}
                address={site.address}
                jobs={jobs}
                expansion={site.expansion}
                checked={site.enabled}
                selectedJobs={site.selectedJobs}
                onDelete={() => this.handleDelete(site.id)}
                onDone={newSite => this.handleSiteDone(site.id, newSite)}
                mapKey={mapKey}
                onExpansionChange={expansion =>
                  this.handleExpansionChange(site.id, expansion)
                }
                onCheckedChange={checked =>
                  this.handleCheckedChange(site.id, checked)
                }
                fenceSizeMax={fenceSizeMax}
              ></SelectPlace>
            ))}
          </div>
        </div>
        <div className="clock-in-place__right">
          <ActiveSites
            key={JSON.stringify(locations)}
            locations={locations}
            mapKey={mapKey}
            count={count}
          ></ActiveSites>
        </div>
      </div>
    );
  }
}

const EnhancedClockInPlace = injectIntl(ClockInPlace, { withRef: true });

ClockInPlace.propTypes = {
  /**
   * 地点数据
   */
  sites: PropTypes.array,
  /**
   * job 数据
   */
  jobs: PropTypes.array,
  /**
   * 考勤打卡-admin key
   */
  mapKey: PropTypes.string.isRequired,
  /**
   * 范围大小
   */
  fenceSizeMax: PropTypes.number,
  /**
   * 点击完成按钮时的回调，参数中包含了最新的地点数据
   */
  onChange: PropTypes.func
};

ClockInPlace.propTypes = {
  sites: [],
  jobs: [],
  fenceSizeMax: 1000
};

export default EnhancedClockInPlace;
